<form class="code-input-form" (paste)="onPaste($event)">
  @for (control of controls; let i = $index; track $index) {
    <mat-form-field appearance="outline">
      <input
        id="otp-{{ i }}"
        matInput
        maxlength="1"
        minLength="1"
        pattern="[0-9]"
        type="text"
        inputmode="numeric"
        autocomplete="off"
        name="otp"
        digitString
        class="centered-input"
        (keydown)="onKeyDown($event, i)"
        [formControl]="control"
        (input)="onInput($event, i)"
      >
    </mat-form-field>
  }
</form>
